module.exports = __webpack_public_path__ + "static/media/icon_nosotros_facil.5bfe3003.svg";